import styled from 'styled-components'

export const ReportCalculatorWrapperDiv = styled.div`
  display: flex;
  gap: 48px;
`

export const OperationSignContainer = styled.span`
  color: ${({ theme }) => theme.colors.gray[40]};
  font-size: 40px;
  line-height: 1;
  vertical-align: middle;
  height: 48px;
`
